
import { Award, LineChart, Users } from "lucide-react";
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";

const TrustIndicators = () => {
  const indicators = [
    {
      icon: <Award className="w-10 h-10 text-corporate-secondary-100" strokeWidth={1.5} />,
      title: "Verified crypto strategies from professional trading experts"
    }, 
    {
      icon: <LineChart className="w-10 h-10 text-corporate-secondary-100" strokeWidth={1.5} />,
      title: "Trusted Crypto exchanges with millions of users"
    }, 
    {
      icon: <Users className="w-10 h-10 text-corporate-secondary-100" strokeWidth={1.5} />,
      title: "Active community of successful traders"
    }
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  
  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <section className="px-4 bg-corporate-neutral-25 py-20 border-t border-corporate-neutral-25">
      <div className="container mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-corporate-primary-75 mb-4">
            Why trust us?
          </h2>
          <p className="text-corporate-neutral-75 text-lg max-w-2xl mx-auto">
            Join thousands of traders who rely on our platform
          </p>
        </motion.div>
        
        <motion.div 
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16"
        >
          {indicators.map((indicator, index) => (
            <motion.div
              key={index}
              variants={item}
            >
              <Card 
                className="bg-corporate-primary-100 p-8 rounded-2xl border-none text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2 h-full flex flex-col items-center justify-center"
              >
                <div className="bg-corporate-primary-75 rounded-full p-5 mb-6 shadow-lg">
                  {indicator.icon}
                </div>
                <h3 className="text-lg text-corporate-white font-medium leading-tight">
                  {indicator.title}
                </h3>
              </Card>
            </motion.div>
          ))}
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="bg-corporate-white p-8 rounded-xl border border-corporate-neutral-25 shadow-sm max-w-4xl mx-auto"
        >
          <p className="text-center text-corporate-primary-75 text-lg leading-relaxed">
            METRADE serves as a gateway, enabling customers to enjoy fully automated trading on worldwide leading exchanges. The trading is carried out by external strategy providers who offer their strategies to METRADE MARKETPLACE customers.
          </p>

          
        </motion.div>
        
<div className="trustpilot-widget pt-8" data-locale="en-US" data-template-id="56278e9abfbbba0bdcd568bc" data-businessunit-id="651c1a0818c02ea3ff831682" data-style-height="52px" data-style-width="100%">
<a href="https://www.trustpilot.com/review/metrade.io" target="_blank" rel="noopener">Trustpilot</a>
</div>

      </div>
    </section>
  );
};

export default TrustIndicators;
